module.exports = __webpack_public_path__ + "static/media/wwf.7a6f3e0f.svg";